// LLC: wishlist hearts on product cards (blocks/_product-card-gallery.liquid renders the buttons).
// Swishlist only wires up buttons when its product-card runtime runs, so run it once Swishlist has
// loaded, and again whenever new cards appear (Show more products, filters, sorting).
(() => {
  const pending = () => document.querySelector('.llc-card-wl:not(.st-initialized)');
  const run = () => {
    if (!pending()) return;
    if (window.SWishlist && typeof window.SWishlist.loadProductCardRuntime === 'function') {
      try { window.SWishlist.loadProductCardRuntime(); } catch (e) { /* Swishlist not ready yet */ }
    }
  };
  let tries = 0;
  const waitForSwishlist = setInterval(() => {
    tries += 1;
    if (window.SWishlist && typeof window.SWishlist.loadProductCardRuntime === 'function') { clearInterval(waitForSwishlist); run(); }
    if (tries > 40) clearInterval(waitForSwishlist);
  }, 250);
  let timer;
  new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(run, 250); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
